let appConfig: Record<string, string> | null = null
let decryptedConfig: Record<string, string> = {}

function decryptValueSync(encryptedValue: string): string {
  try {
    // Swap
    const swappedValue =
      encryptedValue.slice(-1) +
      encryptedValue.slice(1, -1) +
      encryptedValue[0]

    // Decode base64
    const decodedBytes = Uint8Array.from(atob(swappedValue), (c) =>
      c.charCodeAt(0)
    )
    return new TextDecoder().decode(decodedBytes)
  } catch (error) {
    console.error("Decryption failed:", error)
    return encryptedValue
  }
}

const loadConfigSync = (): void => {
  try {
    const xhr = new XMLHttpRequest()
    xhr.open('GET', '/config.json', false)
    xhr.send()

    if (xhr.status === 200) {
      appConfig = JSON.parse(xhr.responseText)
      // Decrypt all values synchronously
      Object.entries(appConfig || {}).forEach(([key, value]) => {
        try {
          const decryptedValue = decryptValueSync(value)
          decryptedConfig[key] = decryptedValue
          console.log(`Decrypted Org[${value}]${key}:`, decryptedValue)
        } catch (error) {
          console.error(`Failed to decrypt ${key}:`, error)
          decryptedConfig[key] = value
        }
      })
      console.log("Config Loaded and Decrypted:", decryptedConfig)
    } else {
      console.log("Config file not found, using fallback values")
      appConfig = {}
      decryptedConfig = {}
    }
  } catch (error) {
    console.error("Failed to load config.json, using fallback values", error)
    appConfig = {}
    decryptedConfig = {}
  }
}

export const getEnv = (key: string): string => {
  if (!appConfig || !appConfig[key]) {
    console.log("Loading config...")
    loadConfigSync()
  }

  const stack = new Error().stack
  const callerLine = stack?.split('\n')[2] || 'unknown'
  const matches = callerLine.match(/at (.*) \((.*):(\d+):(\d+)\)/)
  const functionName = matches?.[1] || 'unknown'
  const filePath = matches?.[2] || 'unknown'
  const line = matches?.[3] || '0'
  const column = matches?.[4] || '0'

  // Get pre-decrypted value or fallback
  const result = decryptedConfig[key] ?? process.env[key] ?? ""

  console.log("GetEnv called from:")
  console.log(` File: ${filePath}`)
  console.log(` Function: ${functionName}`)
  console.log(` Line: ${line}, Column: ${column}`)
  console.log(` Key: ${key} | Value: ${result}`)

  return result
}